import { z } from 'zod';
import { Config, Rule as RuleBase } from './types';

export const Rule = RuleBase.extend({
  enabledServices: z.number(),
  totalServices: z.number(),
});

export type Rule = z.infer<typeof Rule>;

export const GetRulesResponse = z.object({
  rules: z.array(Rule),
});

export type GetRulesResponse = z.infer<typeof GetRulesResponse>;

export const GetRulesNamesResponse = z.object({
  rules: z.array(z.object({ id: z.string(), name: z.string() })),
});

export type GetRulesNamesResponse = z.infer<typeof GetRulesNamesResponse>;

export const ServiceConfig = z.object({
  id: z.string(),
  serviceIds: z.array(z.number()),
  config: Config,
  enabled: z.boolean(),
  lastChangedAt: z.coerce.date()
});

export type ServiceConfig = z.infer<typeof ServiceConfig>;

export const GetRuleResponse = z.object({
  rule: Rule.omit({ enabledServices: true, totalServices: true }),
  accountConfig: z.object({
    config: Config,
    lastChangedAt: z.coerce.date(),
  }).nullable(),
  serviceConfigs: z.array(ServiceConfig),
});

export type GetRuleResponse = z.infer<typeof GetRuleResponse>;

export const UpdateAccountConfigRequest = z.object({
  enabled: z.boolean(),
  config: Config,
});

export type UpdateAccountConfigRequest = z.infer<typeof UpdateAccountConfigRequest>;

export const ServiceConfigRequest = z.object({
  serviceIds: z.array(z.number()),
  config: Config,
  enabled: z.boolean(),
});

export type ServiceConfigRequest = z.infer<typeof ServiceConfigRequest>;